import { WidgetViewState } from '@/components/widget/WidgetOpeningManager/types';
import { ChannelOptions } from './widgetConfig';


export enum WidgetLocation {
  EAST_ASIA = 'eastasia',
  EAST_US = 'eastus',
  SOUTHEAST_ASIA = 'southeastasia',
  UAE_NORTH = 'uaenorth',
  WEST_EUROPE = 'westeurope',
}
export interface WidgetDataAttr {
  companyId: string | null;
  location: WidgetLocation | null;
  widgetId: string | null;
  env: string;
}

export interface WidgetUIState {
  isLoading: boolean;
  error: string | null;
  pendingMessage: string | null;
  autoSendOnOpen: boolean;
  currentView: WidgetViewState;
  currentChannelDetailType: keyof ChannelOptions | null;
}

// Helper function types for state checks
export type WidgetStateChecker = {
  isWidgetVisible: () => boolean;
  isWidgetMinimized: () => boolean;
};

export interface WidgetUIActions {
  toggleWidget: () => void;
  setIsLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  clearError: () => void;
  openWidgetWithMessage: (message: string) => void;
  clearPendingMessage: () => void;
  setCurrentView: (view: WidgetViewState) => void;
  setChannelDetailType: (channelType: keyof ChannelOptions | null) => void;
}

export interface WidgetUIStore extends WidgetUIState {
  actions: WidgetUIActions;
  // Helper functions for state checks
  isWidgetVisible: () => boolean;
  isWidgetMinimized: () => boolean;
}

// Export the new config types for convenience
export type {
  WidgetConfigResponse,
  WidgetConfigSettings,
  WidgetBranding,
  PreChatForm,
} from './widgetConfig';
